import globals from "../../globals";
import { _sendWithAxios, _sendWithAxiosBlob } from "../api";

const REACT_APP_URL_BASE_API = globals.REACT_APP_URL_BASE_API;

export const listarPedidos = async (filtro, pagina) => {
  try {
    const response = await _sendWithAxios(
      `${REACT_APP_URL_BASE_API}Pedido/listagem/${pagina}/10`, 
      "POST",
      { filtro: filtro }
    );
    return response;
  } catch (error) {
    console.error("Erro ao listar produtos:", error);
    throw error;
  }
};
export const gerarExelPedido = async () => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}Pedido/gerar-excel-pedidos`,
    "GET"
  );
};
export const gerarExelPedidoDetalhe = async (idPedido) => {
  return await _sendWithAxiosBlob(
    `${REACT_APP_URL_BASE_API}Pedido/gerar-excel-pedidos-detalhado/${idPedido}`,
    "GET"
  );
};

export const detalhePedido = async (idPedido) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Pedido/detalhe/${idPedido}`,
    "GET"
  );
};
export const alterarPedido = async (data) => {
  return await _sendWithAxios(
    `${REACT_APP_URL_BASE_API}Pedido/alterar`,
    "PUT",
    data
  );
};
